import {GESTION_OPERATIVA_EDIT_DELIVERY_COSTS} from "../constants"

export function editDeliveryCosts(newValue) {
    
    return  (dispatch) => {
      dispatch({
        type: GESTION_OPERATIVA_EDIT_DELIVERY_COSTS,
        data: newValue
      })
    }
  }